module.exports = __webpack_public_path__ + "img/30.0e776dca.png";